import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
@Component({
  selector: "app-person-import-management-default",
  templateUrl: "./import-management-default.component.html",
  styleUrls: ["./import-management-default.component.css"],
})
export class PersonImportManagementDefaultComponent {
  @Input() import_history_list: any[] = [];
  @Input() language_list: any[] = [];
  @Input() import_language_id: any;

  // 親からの状態も受け取るが、内部状態(internal_file_selected)を優先して表示に使う
  @Input() set file_selected(val: boolean) {
    this.internal_file_selected = val;
  }

  @Output() onImport = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onErrorClick = new EventEmitter<any>();
  @Output() onReload = new EventEmitter<void>();
  @Output() onFileSelect = new EventEmitter<any>();
  @Output() import_language_idChange = new EventEmitter<any>();

  internal_file_selected: boolean = false;
  selected_file_name: string = "";

  // ファイルが選択された瞬間に実行
  selectedFile(files: FileList) {
    if (files && files.length > 0) {
      this.internal_file_selected = true;
      this.selected_file_name = files[0].name;
      // 親コンポーネントにファイルを渡す
      this.onFileSelect.emit(files);
    } else {
      this.internal_file_selected = false;
      this.selected_file_name = "";
    }
  }

  // 取り込み実行後、またはリセットが必要な時のためのメソッド
  resetFile() {
    this.internal_file_selected = false;
    this.selected_file_name = "";
  }

  onLanguageChange(val: any) {
    this.import_language_idChange.emit(val);
  }
  getBadgeClass(h: any): string {
    if (!h) return "badge-soft-secondary";
    return h.import_result == 1
      ? "badge-soft-success"
      : h.import_result == 9
        ? "badge-soft-secondary"
        : "badge-soft-danger";
  }
  getStatusLabel(h: any): string {
    if (!h) return "";
    return h.import_result == 1
      ? "完了"
      : h.import_result == 9
        ? "削除"
        : "エラー";
  }
  importAction(files: FileList) {
    if (files && files.length > 0) this.onImport.emit(files);
  }
  reload() {
    this.onReload.emit();
  }
  delpersons(h: any) {
    this.onDelete.emit(h);
  }
  showerror(h: any) {
    this.onErrorClick.emit(h);
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/import-management/default/import-management-default.component.ts